import styled from 'styled-components'

const height = 40

const StyledContainer = styled.article`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const StyledHeader = styled.header`
  display: flex;
  flex: 0 0 auto;
  width: 100%;
  position: relative;
  height: ${ height }px;
  background: ${ ({ theme }) => theme.colors.grey.light };
  border-radius: 2px;
  border: 1.5px solid transparent;
  cursor: pointer;
  box-sizing: border-box;
  margin-bottom: 8px;
  &.open {
    border: 1.5px solid ${ ({ theme }) => theme.colors.primary.medium };
  }
  &.invalid {
    border: 1.5px solid ${ ({ theme }) => theme.colors.system.error };
    .value {
      background: ${ ({ theme }) => theme.colors.system.error }35;
      color: ${ ({ theme }) => theme.colors.system.error };
    }
  }
  &.disabled {
    background: ${ ({ theme }) => theme.colors.grey.medium };
    cursor: not-allowed;
  }
  .wrapper {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    overflow: hidden;
    background-color: ${ ({ theme }) => theme.colors.white };
    padding: 0 8px 0 12px;
    .search-input {
      display: flex;
      width: 100%;
      height: 40px;
      outline: 0;
      font-size: 14px;
      color: ${ ({ theme }) => theme.colors.typography.light };
      font-family: ${ ({ theme }) => theme.fontFamily };
      margin: 0;
      border: 0;
      border-bottom: 1px solid ${ ({ theme }) => theme.colors.grey.medium };
      box-sizing: border-box;
    }
    .values {
      display: flex;
      flex-direction: row;
      flex: 1;
      overflow: hidden;
      margin: 0 8px 0 0;
      .placeholder {
        color: ${ ({ theme }) => theme.colors.typography.light };
        font-family: ${ ({ theme }) => theme.fontFamily };
        user-select: none;
      }
      .value {
        overflow: hidden;
        margin: 0 8px 0 0;
      }
    }
    .icon {
      font-size: 22px;
      color: ${ ({ theme }) => theme.colors.typography.medium };
    }
  }
`

const StyledContent = styled.section`
  overflow-y: auto;
`

export { StyledHeader, StyledContent, StyledContainer }
